import type { RootState } from 'store';

export const compareAllInfoSelector = (state: RootState) => state.customer.customerCompare;
export const compareItemsSelector = (state: RootState) =>
  state.customer.customerCompare.compareItems;
export const compareTotalSelector = (state: RootState) =>
  state.customer.customerCompare.totalCompareProducts;
export const compareLoadingSelector = (state: RootState) => state.customer.customerCompare.loading;
